import { Product } from "../product/product";

export class Category {
    categ: boolean;
    categId: number;
    class: string;
    color: string;
    count: number;
    id: string;
    margin: string;
    mediaCategorie: number;
    open: boolean;
    ordinal: number;
    price: number;
    priceText: string;
    products: Array<Product>;
    showLine: boolean;
    start: string;
    title: string;
    titleShort: string;
    width: string;
    constructor(data) {

        this.categ = data.categ;
        this.categId = data.categId;
        this.class = data.class;
        this.color = data.color;
        this.count = data.count;
        this.id = data.id;
        this.margin = data.margin;
        this.mediaCategorie = data.mediaCategorie;
        this.open = data.open;
        this.ordinal = data.ordinal;
        this.price = data.price;
        this.priceText = data.priceText;
        this.products = data.products.map((item) => new Product(item));
        this.showLine = data.showLine;
        this.start = data.start;
        this.title = data.title;
        this.titleShort = data.titleShort;
        this.width = data.width;

    }


}


// WEBPACK FOOTER //
// ./src/app/components/class/category/category.ts